import * as tslib_1 from "tslib";
import { ROUTER_NAVIGATION } from '@ngrx/router-store';
import { select, Store } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { toPayload, withPredicateFrom } from '../../core/helpers/rx-pipes';
import { CartService } from '../services/cart-service';
import * as cart from '../actions/cart';
import * as fromCart from '../reducers';
import * as fromAuth from '../../auth/reducers';
var CartEffects = /** @class */ (function () {
    function CartEffects(actions$, store, cartSvc) {
        var _this = this;
        this.actions$ = actions$;
        this.store = store;
        this.cartSvc = cartSvc;
        this.getCartOnNavigate$ = this.actions$.ofType(ROUTER_NAVIGATION)
            .pipe(toPayload(), filter(function (payload) { return payload.routerState.url.indexOf('/logout') === -1; }), withPredicateFrom(this.store.pipe(select(fromAuth.isLoggedIn))), withPredicateFrom(this.store.pipe(select(fromAuth.isCustomerSelected))), map(function (router) {
            if (router.routerState.url.indexOf('/checkout') > -1) {
                return new cart.Get(true);
            }
            else {
                return new cart.Get();
            }
        }));
        this.getCart$ = this.actions$.ofType(cart.GET)
            .pipe(withLatestFrom(this.store.pipe(select(fromAuth.getCustomerId))), switchMap(function (_a) {
            var action = _a[0], customerId = _a[1];
            return _this.cartSvc.getOpenCart(customerId, action.includeExtraCosts)
                .pipe(map(function (order) { return new cart.GetSuccess(order); }), catchError(function (e) { return of(new cart.GetFailed(e)); }));
        }));
        this.addCart$ = this.actions$.ofType(cart.ADD)
            .pipe(toPayload(), withLatestFrom(this.store.pipe(select(fromCart.hasActiveCart)), this.store.pipe(select(fromCart.getOrderId)), this.store.pipe(select(fromAuth.getCustomerId)), function (line, active, orderId, customerId) { return ({ line: line, active: active, orderId: orderId, customerId: customerId }); }), switchMap(function (state) {
            return (state.active
                ? _this.cartSvc.setLine(state.customerId, state.orderId, state.line)
                : _this.cartSvc.createOrder(state.customerId, state.line)).pipe(map(function (order) { return new cart.AddSuccess(order); }), catchError(function (e) { return of(new cart.AddFailed(e)); }));
        }));
        this.changeCart$ = this.actions$.ofType(cart.CHANGE)
            .pipe(toPayload(), withLatestFrom(this.store.pipe(select(fromCart.getOrderId)), this.store.pipe(select(fromAuth.getCustomerId)), function (line, orderId, customerId) { return ({ line: line, orderId: orderId, customerId: customerId }); }), switchMap(function (state) {
            return _this.cartSvc.setLine(state.customerId, state.orderId, state.line)
                .pipe(map(function (order) { return new cart.ChangeSuccess(order); }), catchError(function (e) { return of(new cart.ChangeFailed(e)); }));
        }));
        this.deleteLine$ = this.actions$.ofType(cart.REMOVE)
            .pipe(withLatestFrom(this.store.pipe(select(fromCart.getOrderId)), this.store.pipe(select(fromAuth.getCustomerId)), function (action, orderId, customerId) { return ({ action: action, orderId: orderId, customerId: customerId }); }), switchMap(function (state) {
            return _this.cartSvc.deleteLine(state.orderId, state.action.payload.lineId, state.customerId, state.action.payload.includeExtraCosts)
                .pipe(map(function (order) { return new cart.RemoveSuccess(order); }), catchError(function (e) { return of(new cart.RemoveFailed(e)); }));
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CartEffects.prototype, "getCartOnNavigate$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CartEffects.prototype, "getCart$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CartEffects.prototype, "addCart$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CartEffects.prototype, "changeCart$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], CartEffects.prototype, "deleteLine$", void 0);
    return CartEffects;
}());
export { CartEffects };
